import React, { Component } from 'react';
import { observer } from 'mobx-react';
import style from './Allergen.module.scss';

import DishForm from 'stores/Forms/DishForm/DishForm';

import { FormControl } from 'components/Form/FormControl/FormControl';
import SelectField from 'components/Form/Fields/Select/SelectField';
import AllergenOption from './AllergenOption';

@observer
class Allergens extends Component<{ form: DishForm }> {
  render() {
    const { form } = this.props;

    return (
      <FormControl
        form={form}
        name="itemAllergens"
        className={style.field__select}
        render={props => (
          <SelectField
            {...props}
            isMulti
            options={form.allergensValues}
            components={{
              Option: AllergenOption,
              MultiValueLabel: AllergenOption,
            }}
          />
        )}
      />
    );
  }
}

export default Allergens;
